import angular from 'angular';

const IMAGE_TYPES = {
    POSITION: 'POSITION',
    CANDIDATE: 'CANDIDATE',
    EMPLOYER: 'EMPLOYER',
    RECRUITER: 'RECRUITER',
    USER: 'USER',
};

const IMAGE_TYPE_PLACEHOLDER = {
    [IMAGE_TYPES.POSITION]: 'assets/img/svg-icons/company-icon.svg',
    [IMAGE_TYPES.EMPLOYER]: 'assets/img/company-logo.png',
    [IMAGE_TYPES.CANDIDATE]: 'assets/img/no_profile_picture_100.jpg',
    [IMAGE_TYPES.RECRUITER]: 'assets/img/no_profile_picture_100.jpg',
    [IMAGE_TYPES.USER]: 'assets/img/no_profile_picture_100.jpg',
};

angular.module('TALENYA-FE')
    .directive('placeholderType', () => ({
        restrict: 'A',
        link: (scope, element, attr) => {
            const placeholderType = attr.placeholderType;
            const placeholderSrc = IMAGE_TYPE_PLACEHOLDER[placeholderType];

            if (!element.attr('src')) {
                element.attr('src', placeholderSrc);
            }

            element.on('error', () => element.attr('src', placeholderSrc));
        },
    }));
